<template>
  <nav class="navbar navbar-expand-xl navbar-custom" style="padding-bottom: -10px; ">
    <div class="container-md container-layout">
      <!-- Logo 在左边 -->
      <router-link to="/official" class="navbar-brand">
        <img src="@/assets/aogs2025/img/isacio.png" alt="CoolBrand" id="logo" class="navlogo"><span class="d-none d-xl-inline" style="font-size: 16px; font-weight: bold;color: white;">INTERNATIONAL SOCIETY FOR APPLIED AND 
          COMPUTATIONAL IMAGING</span>
      </router-link>
      
      <!-- 移动端汉堡菜单按钮 -->
      <button type="button" class="navbar-toggler" data-toggle="collapse" data-target="#navbarCollapse"
        @click="changeNavBg('red')" aria-controls="navbarCollapse" aria-expanded="false" aria-label="Toggle navigation">
        <span class="navbar-toggler-icon">
          <i class="fa fa-bars" style="color:#fff; font-size:25px;"></i>
        </span>
      </button>
      
      <!-- 导航菜单在右边 -->
      <div class="collapse navbar-collapse" id="navbarCollapse">
        <ul class="navbar-nav ml-auto">
          <li class="nav-item dropdown">
            <router-link class="nav-link btn4" to="/official" role="button"
              aria-haspopup="true" aria-expanded="false">HOME</router-link>
          </li>
          <li class="nav-item dropdown">
              <a class="nav-link btn4" href="#" @click="scrollToAnchor('aboutUS')" role="button"
              aria-haspopup="true" aria-expanded="false">ABOUT ISACI</a>
          </li>
          <!-- <li class="nav-item dropdown">
            <router-link class="nav-link btn4" to="/announcements" role="button"
              aria-haspopup="true" aria-expanded="false">ANNOUNCEMENTS</router-link>
          </li>
          <li class="nav-item dropdown">
            <a class="nav-link btn4 dropdown-toggle" href="#" id="membershipDropdown" role="button"
              data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">MEMBERSHIP</a>
            <div class="dropdown-menu dropdown-menu-lg-start dropdown-min" aria-labelledby="membershipDropdown">
              <h6 class="title"><router-link class="navTitle_clickable" to="/membership/benefits">Benefits </router-link></h6>
              <div class="dropdown-divider"></div>
              <h6 class="title"><router-link class="navTitle_clickable" to="/membership/eligibility">Eligibility </router-link></h6>
              <div class="dropdown-divider"></div>
              <h6 class="title"><router-link class="navTitle_clickable" to="/membership/listing">Member Listing</router-link></h6>
               <router-link class="dropdown-item" to="/membership/application">Application</router-link>
              <div class="dropdown-divider"></div>
              <h6 class="title"><router-link class="navTitle_clickable" to="/membership/amos">What is AMOS </router-link></h6>
            </div>
          </li>
          <li class="nav-item dropdown">
            <a class="nav-link btn4 dropdown-toggle" href="#" id="eventsDropdown" role="button"
              data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">EVENTS & RECORDS</a>
            <div class="dropdown-menu dropdown-menu-lg-start dropdown-large" aria-labelledby="eventsDropdown" style="min-width: 20rem;">
              <div class="row">
                <div class="col-sm-12">
                  <b class="navHeader">ISACI Annual Meetings</b><br />
                  <p class="navsubTitle"><b>Venues for Future Annual Meetings: Email Proposal/Enquiry to <a href="mailto:admin@asiaoceania.org">admin@asiaoceania.org</a></b></p>
                  <div class="dropdown-divider"></div>
                  <div class="row">
                    <div class="col-sm-12">
                      <p class="navsubTitle"><b>Annual Meetings</b></p>
                      <div class="row">
                        <div class="col-sm-12">
                          <ul class="list-unstyled">
                            <li class="items"><router-link class="navItems" to="/annual-meetings">2024 - 2028</router-link></li>
                            <li class="items"><a class="navItems" href="./public.asp_page=annual_meetings_2023.asp.html">2019 - 2023</a></li>
                          </ul>
                        </div>
                      </div>
                      <div class="dropdown-divider"></div>
                      <p class="navsubTitle"><b>Annual General Meetings</b></p>
                      <div class="row">
                        <div class="col-sm-12">
                          <ul class="list-unstyled">
                            <li class="items"><a class="navItems" href="./public.asp_page=annual_general_meeting_2024.asp.html">AOGS2024</a></li>
                            <li class="items"><a class="navItems" href="./public.asp_page=annual_general_meeting_2023.asp.html">AOGS2023</a></li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="dropdown-divider"></div>
                  <b class="navHeader">Meeting & Event Photos <font style="font-size: 13px;"><router-link to="/photo-gallery">View All</router-link> </font></b>
                  <div class="dropdown-divider"></div>
                  <b class="navHeader">Outreach & Communication Activities <font style="font-size: 13px;"><router-link to="/outreach">View All</router-link> </font></b>
                  <div class="dropdown-divider"></div>
                  <b class="navHeader">Collaboration Invitation </b><br />
                  <p class="navsubTitle"><b>Aim is to improve learning, promote engagement and create partnership between the communities. Email Proposal/Enquiry to <a href="mailto:admin@asiaoceania.org">admin@asiaoceania.org</a></b></p>
                </div>
              </div>
            </div>
          </li> -->
          <!-- <li class="nav-item">
            <a class="nav-link btn4" href="https://isacio.apiwww.cn/" role="button">LOGIN</a>
          </li> -->
          <li class="nav-item">
            <router-link class="nav-link btn4" to="/login" role="button">LOGIN</router-link>
          </li>
        </ul>
      </div>
    </div>
  </nav>
</template>

<script>
export default {
  name: 'TheNavbar',
  methods: {


    changeNavBg(color) {
      // 可根据需要实现导航栏背景色切换
      console.log('Navigation background changed to:', color);
    },
    // 初始化Bootstrap组件
    initBootstrap() {
      
      // 使用Bootstrap 5的方法初始化
      if (window.bootstrap) {
        // 初始化所有下拉菜单
        const dropdownElementList = [].slice.call(document.querySelectorAll('.dropdown-toggle'));
        dropdownElementList.map(function (dropdownToggleEl) {
          return new window.bootstrap.Dropdown(dropdownToggleEl);
        });
        
        // 初始化折叠菜单
        const collapseElementList = [].slice.call(document.querySelectorAll('.navbar-collapse'));
        collapseElementList.map(function (collapseEl) {
          return new window.bootstrap.Collapse(collapseEl, {
            toggle: false
          });
        });
        
        // 移动端菜单点击事件
        const navbarToggler = document.querySelector('.navbar-toggler');
        if (navbarToggler) {
          navbarToggler.addEventListener('click', function(e) {
            e.preventDefault();
            const target = this.getAttribute('data-target') || this.getAttribute('data-bs-target');
            const collapseElement = document.querySelector(target);
            if (collapseElement) {
              const bsCollapse = new window.bootstrap.Collapse(collapseElement);
              bsCollapse.toggle();
            }
          });
        }
        
        // 移动端下拉菜单点击事件 - 修复移动端下拉菜单问题
        const mobileDropdownToggles = document.querySelectorAll('.dropdown-toggle');
        mobileDropdownToggles.forEach(function(toggle) {
          toggle.addEventListener('click', function(e) {
            e.preventDefault();
            e.stopPropagation();
            
            // 获取当前下拉菜单
            const dropdownMenu = this.nextElementSibling;
            const isExpanded = this.getAttribute('aria-expanded') === 'true';
            
            // 关闭其他打开的下拉菜单
            const allDropdowns = document.querySelectorAll('.dropdown-menu.show');
            allDropdowns.forEach(function(dropdown) {
              if (dropdown !== dropdownMenu) {
                dropdown.classList.remove('show');
                const otherToggle = dropdown.previousElementSibling;
                if (otherToggle) {
                  otherToggle.setAttribute('aria-expanded', 'false');
                }
              }
            });
            
            // 切换当前下拉菜单
            if (dropdownMenu) {
              if (isExpanded) {
                // 如果已经展开，则关闭
                dropdownMenu.classList.remove('show');
                this.setAttribute('aria-expanded', 'false');
              } else {
                // 如果未展开，则打开
                dropdownMenu.classList.add('show');
                this.setAttribute('aria-expanded', 'true');
              }
            }
          });
        });
        
        // 点击外部关闭所有下拉菜单
        document.addEventListener('click', function(e) {
          // 检查点击的元素是否是下拉菜单的一部分
          const isDropdownClick = e.target.closest('.dropdown');
          const isDropdownToggle = e.target.closest('.dropdown-toggle');
          
          // 如果不是下拉菜单相关元素，则关闭所有下拉菜单
          if (!isDropdownClick || (isDropdownClick && !isDropdownToggle)) {
            const allDropdowns = document.querySelectorAll('.dropdown-menu.show');
            allDropdowns.forEach(function(dropdown) {
              dropdown.classList.remove('show');
              const toggle = dropdown.previousElementSibling;
              if (toggle && toggle.classList.contains('dropdown-toggle')) {
                toggle.setAttribute('aria-expanded', 'false');
              }
            });
          }
        });
      } else {
        console.error('Bootstrap 5 not available');
      }
    },
    scrollToAnchor(anchorId) {
      // 检查当前是否在首页
      if ( this.$route.path !== '/official') {
        // 如果不在首页，先跳转到首页，然后滚动到锚点
        this.$router.push(`/official#${anchorId}`);
      } else {
        // 如果已经在首页，直接滚动到锚点
        this.$nextTick(() => {
          const element = document.getElementById(anchorId);
          if (element) {
            element.scrollIntoView({ behavior: 'smooth' });
          }
        });
      }
    }
  },
  mounted() {
    // 等待DOM完全加载后初始化
    this.$nextTick(() => {
      // 延迟确保所有依赖都加载完成
      setTimeout(() => {
        this.initBootstrap();
      }, 300);
    });
    
    // 防止下拉菜单点击内部时关闭
    $(document).on('click', '.dropdown-menu', function (e) {
      e.stopPropagation();
    });
  }
}
</script>

<style scoped>
/* 导航栏基础样式 */
.navbar-custom {
  background-color: #175480;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
}

.navbar-brand {
  display: flex;
  align-items: center;
}

.navlogo {
  height: 45px;
  margin: 0 10px;
  width: auto;
}

.navbar-nav {
  margin-left: auto !important;
}

.navbar-nav .nav-item {
  margin: 0 5px;
}

/* 使用原始的btn4样式，不覆盖hover效果 */
.navbar-nav .nav-link {
  color: white !important;
  font-weight: 500;
  padding: 0.5rem 1rem;
  position: relative; /* 为btn4的::before伪元素提供定位上下文 */
}

.navbar-toggler {
  border: none;
  padding: 0.25rem 0.5rem;
}

.navbar-toggler:focus {
  box-shadow: none;
}

/* 移动端样式 */
@media (max-width: 1199.98px) {
  .navbar-collapse {
    background-color: #175480;
    margin-top: 10px;
    border-radius: 8px;
    padding: 10px;
  }
  
  .navbar-nav .nav-item {
    margin: 5px 0;
  }
  
  .dropdown-menu {
    background-color: rgba(255,255,255,0.95);
    border: none;
    box-shadow: 0 4px 12px rgba(0,0,0,0.15);
    position: static !important;
    float: none;
    width: 100%;
    margin-top: 5px;
  }
  
  /* 移动端下拉菜单样式 */
  .dropdown-menu.show {
    display: block !important;
  }
  
  .dropdown-toggle::after {
    float: right;
    margin-top: 8px;
  }
  
  /* 确保移动端下拉菜单内容正确显示 */
  .dropdown-menu .title,
  .dropdown-menu .navTitle_clickable,
  .dropdown-menu .navItems {
    color: #175480 !important;
    text-decoration: none;

  }
  
  .dropdown-menu .title:hover,
  .dropdown-menu .navTitle_clickable:hover,
  .dropdown-menu .navItems:hover {
    background-color: #f8f9fa;
    color: #175480 !important;
  }
}

/* 桌面端下拉菜单样式 */
@media (min-width: 1200px) {
  .dropdown-menu {
    border-radius: 8px;
    border: none;
    box-shadow: 0 4px 12px rgba(0,0,0,0.15);
  }
}

.dropdown-item {
  padding: 0.5rem 1rem;
  color: #175480;
  transition: all 0.2s ease;
}

.dropdown-item:hover {
  background-color: #f8f9fa;
  color: #175480;
}
</style> 
